///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { default: axios } = require("axios");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item_pricing = abcsetup.abc_item_pricing || {};
abcsetup.abc_item_pricing.manage = abcsetup.abc_item_pricing.manage || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item_pricing.manage.imported_zone_pricing = {}
abcsetup.abc_item_pricing.manage.imported_sap_nums = {}
abcsetup.abc_item_pricing.manage.saved_imported_zone_pricing = {}
abcsetup.abc_item_pricing.manage.saved_imported_sap_nums = {}
abcsetup.abc_item_pricing.manage.remaining_limit = 0;
abcsetup.abc_item_pricing.manage.override = false;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item_pricing.manage = {
    init: function () {
        abcsetup.abc_item_pricing.manage._init();
        abcsetup.setTitle('Pricing Management');

        // Pricing Edit modal shown
        $('#edit-pricing').on('show.bs.modal', function (e) {
            $(this).find('.modal-body').html('<center>Loading Pricing Information...</center>');
            axios.get('/api/abc_item_pricing/edit?sap_num=' + $(e.relatedTarget).data('sap_num')).then(response => {
                $(this).find('.modal-feedback').html("");
                $(this).find('.modal-body').html(response.data);
                abcsetup.abc_item_pricing.manage._init_copy();
                abcsetup.abc_item_pricing.manage.calc_margins();

                var sap_num = $("#pricing_modal_sap_num").val();
                var mat_description = $("#pricing_modal_mat_description").val();
                var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());
                var num = $("#pricing_modal_id").val();
                var tr = $(".pricing_update_form.row." + num);
                var map_price = tr.data("map_price");
                var wac_price = tr.data("wac");
                abcsetup.abc_item_pricing.manage.check_imported_pricing(sap_num);
                abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

                $('.edit-pricing').append(' - SAP # : ' + sap_num + ' - Description : ' + mat_description);

            });
        });

        $('#edit-pricing').on('hidden.bs.modal', function() {
            $('.edit-pricing').text('Edit Pricing');
        });

        $(document).on("change", "#import_pricing", function (e) {
            abcsetup.abc_item_pricing.manage.validateInputFile($(this));
        });

        $('#select_all_pricing').change(function() {
            // If the "select-all" checkbox is checked
            if ($(this).prop('checked')) {
                // Select all checkboxes with the class "checkbox"
                $('.row-checkbox').prop('checked', true);
            } else {
                // Otherwise, clear all checkboxes
                $('.row-checkbox').prop('checked', false);
            }
        });

        // Init Pricing Import
        // Check for any stored data
        abcsetup.abc_item_pricing.manage.check_stored_data();
        // Check for any new imported pricing
        var import_html = $('#imported_zone_pricing_object').html();
        var import_sap_html = $('#imported_sap_list_object').html();

        if (import_html) {
            abcsetup.abc_item_pricing.manage.imported_zone_pricing = JSON.parse(import_html);
        }
        if (!($.isEmptyObject(abcsetup.abc_item_pricing.manage.imported_zone_pricing))) {
            localStorage.setItem('import_pricing_object', JSON.stringify(abcsetup.abc_item_pricing.manage.imported_zone_pricing, {}, 4));
            $("button[value='clear_import_data']").show();
            $("button[value='clear_import_data']").removeAttr('disabled');
            $("#import_success_info").show();
        } else if (!($.isEmptyObject(abcsetup.abc_item_pricing.manage.saved_imported_zone_pricing))) {
            abcsetup.abc_item_pricing.manage.imported_zone_pricing = abcsetup.abc_item_pricing.manage.saved_imported_zone_pricing;
            $("button[value='clear_import_data']").show();
            $("button[value='clear_import_data']").removeAttr('disabled');
            $("#import_success_info").show();
        }

        if (import_sap_html) {
            abcsetup.abc_item_pricing.manage.imported_sap_nums = JSON.parse(import_sap_html);
        }

        $(document).on('click', '#brandedpricingmanagement-table tbody tr', function (event) {
            $("#brandedpricingmanagement-table tbody tr").removeClass('row_selected');
            $(this).addClass('row_selected');
        });

        $('#column-search-modal').on('show.bs.modal', function (e) {
            setTimeout(function() {
                let label_cell = $('#column-search-modal td:contains("Planogram Category")');
                let select = label_cell.next().find('select');
                let drop_down_parent = $(document.body);

                select.find('option').each(function() {
                    if ($(this).val() === '') {
                        $(this).remove();
                    }
                });

                select.val(null).trigger('change');

                if (select.parents('.modal.in:first').length !== 0) {
                    drop_down_parent = select.parents('.modal.in:first');
                }

                select.select2({
                    width: '100%',
                    multiple: true,
                    dropdownParent: $('#column-search-modal')
                });
            }, 75);
        });
    },


    validateInputFile: function (fileInput) {
        const _this = this;
        let file = fileInput[0];
        let errors = [];

        if (file.files.length > 0) {
            const column_map = ['sap_num', 'z1_price', 'z2_price', 'z3_price', 'z4_price', 'z5_price'];

            abcsetup.blockUI(true);
            abcsetup.excel.readFile(file, function (data) {
                let rows = abcsetup.excel.toArray(data, column_map);
                let dataArray = rows.map(row => ({
                    sap_num: row.sap_num,
                    z1_price: row.z1_price,
                    z2_price: row.z2_price,
                    z3_price: row.z3_price,
                    z4_price: row.z4_price,
                    z5_price: row.z5_price,
                }));

                axios.post('/api/abc_item_pricing/validate_pricing', { data: dataArray }).then(response => {
                    const { all_invalid_data, valid_data } = response.data;
                    let validItemCount = valid_data.length;
                    let invalidItemCount = all_invalid_data.length;

                    if (valid_data.length > 0) {
                        _this.submitValidData(valid_data);
                    }

                    if (all_invalid_data.length > 0) {
                        _this.displayErrorTable(all_invalid_data, validItemCount, invalidItemCount);
                    } else {
                        abcsetup.alerts.show('Pricing Updated',
                            `Pricing has been validated and no errors were found. Prices have been updated.` +
                            `<div><strong>Total Valid Items: ${validItemCount}</strong></div>` +
                            `<div><strong>Total Invalid Items: ${invalidItemCount}</strong></div>`
                        );
                    }
                });
            }, true);
        }
    },

    submitValidData: function (validData) {
        axios.post('/api/abc_item_pricing/import_pricing', { data: validData }).then(response => {
            console.log("Data updated: " + JSON.stringify(response.data));
            // abcsetup.alerts.show('Pricing Updated', 'Pricing has been successfully updated.');
        }).catch(error => {
            abcsetup.alerts.show('Update Failed', 'There was an error updating the pricing data.');
        });
    },

    displayErrorTable: function (all_invalid_data, validItemCount, invalidItemCount) {
        const _this = this;
        let warningBanner = `
            <div class="alert alert-warning" role="alert">
                Items successfully priced: <strong>${validItemCount}</strong><br>
                Items with errors: <strong>${invalidItemCount}</strong><br><br>
                Items with errors are shown below. Please review and correct the pricing data.
            </div>
        `;

        let errorTable = warningBanner + `
            <div class="table-responsive">
                <table id="pricing-import-table" class="table table-bordered table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th><input type="checkbox" id="check-all"></th>
                            <th>SAP #</th>
                            <th>Z1 Price</th>
                            <th>Z2 Price</th>
                            <th>Z3 Price</th>
                            <th>Z4 Price</th>
                            <th>Z5 Price</th>
                        </tr>
                    </thead>
                    <tbody>`;

            let count = 1;
            all_invalid_data.forEach((row, index) => {
                errorTable += `<tr id="row-${count}" data-row-id="${count}">`;
                let sapNumInputClass = row.invalid_fields.includes('sap_num') ? 'is-invalid' : '';
                let sapNumTooltip = row.validation_tooltips.sap_num ? row.validation_tooltips.sap_num.join('\n') : '';

                errorTable += `
                    <td><input type="checkbox" class="row-checkbox" data-row-id="row-${count}"></td>
                    <td><input type="text" class="form-control rounded ${sapNumInputClass}" name="errors[${index}][sap_num]" value="${row.sap_num}"
                    ${sapNumTooltip ? `data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="${sapNumTooltip}"` : ''}
                    readonly></td>`;

                ['z1_price', 'z2_price', 'z3_price', 'z4_price', 'z5_price'].forEach(zone => {
                    let inputClass = row.invalid_fields.includes(zone) ? 'is-invalid' : '';
                    let tooltip = row.validation_tooltips[zone] ? row.validation_tooltips[zone].join('\n') : '';
                    let formattedValue = parseFloat(row[zone]).toFixed(2);

                    errorTable += `
                        <td>
                            <input type="text" class="form-control rounded ${inputClass}"
                                   name="errors[${index}][${zone}]"
                                   value="${formattedValue}"
                                   ${tooltip ? `data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" title="${tooltip}"` : ''}
                                   readonly>
                        </td>`;
                });

                errorTable += '</tr>';
                count++;
            });

        errorTable += `
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-end mt-3">
                <button id="submit-errors" class="btn btn-primary" disabled>Submit Pricing</button>
                <button id="bypass-errors" class="btn btn-warning ml-2" disabled>Bypass Validation</button>
                <button class="btn btn-secondary ml-2" data-dismiss="modal">Close</button>
            </div>`;

        abcsetup.alerts.show('Import Errors', errorTable, null, {backdrop: 'static'});
        $('.modal-dialog').css('max-width', '80%');
        $('.modal-footer').hide();
        $('.close').hide();

        $(document).ready(function () {
            $('[data-bs-toggle="tooltip"]').tooltip();

            $('#check-all').on('change', function () {
                let checked = $(this).is(':checked');
                $('.row-checkbox').prop('checked', checked);
                $('.row-checkbox').each(function () {
                    let row = $(this).closest('tr');
                    row.find('input[type="text"]').not('[name$="sap_num"]').prop('readonly', !checked);
                });
                $('#submit-errors').prop('disabled', !checked);
                $('#bypass-errors').prop('disabled', !checked);
            });

            $('.row-checkbox').on('change', function () {
                const anyChecked = $('.row-checkbox:checked').length > 0;
                $('#submit-errors').prop('disabled', !anyChecked);
                $('#bypass-errors').prop('disabled', !anyChecked);

                $(this).closest('tr').find('input[type="text"]').not('[name$="sap_num"]').prop('readonly', !$(this).is(':checked'));
            });

            $('#submit-errors').on('click', function () {
                _this.submitCorrectedData();
            });

            $('#bypass-errors').on('click', function () {
                _this.bypassErrors();
            });
        });
    },

    submitCorrectedData: function () {
        const _this = this;
        let correctedData = [];
        let rowsToRemove = [];

        $('#pricing-import-table tbody tr').each(function () {
            const checkbox = $(this).find('.row-checkbox');
            if (checkbox.is(':checked')) {
                correctedData.push({
                    sap_num: $(this).find('input[name*="sap_num"]').val(),
                    z1_price: $(this).find('input[name*="z1_price"]').val(),
                    z2_price: $(this).find('input[name*="z2_price"]').val(),
                    z3_price: $(this).find('input[name*="z3_price"]').val(),
                    z4_price: $(this).find('input[name*="z4_price"]').val(),
                    z5_price: $(this).find('input[name*="z5_price"]').val(),
                });
                rowsToRemove.push($(this));
            }
        });

        if (correctedData.length === 0) return;

        axios.post('/api/abc_item_pricing/validate_pricing', { data: correctedData }).then(response => {
            const { all_invalid_data, valid_data } = response.data;

            valid_data.forEach(validItem => {
                _this.submitValidData(valid_data);
                $('#pricing-import-table tbody tr').each(function () {
                    const sap_num = $(this).find('input[name*="sap_num"]').val();
                    if (sap_num === validItem.sap_num) {
                        $(this).remove();
                    }
                });
            });

            // Check if there are no more rows in the table
            if ($('#pricing-import-table tbody tr').length === 0) {
                $('#check-all').prop('checked', false);
                $('#pricing-import-table tbody').html(`
                    <tr>
                        <td colspan="7" class="text-center">No items to price</td>
                    </tr>
                `);

                $('#submit-errors').hide();
                $('#bypass-errors').hide();
            }

        }).catch(error => {
            abcsetup.alerts.show('Pricing Not Updated', 'There was an error updating the pricing data.');
        });
    },

    bypassErrors: function () {
        const _this = this;
        let bypassedData = [];
        let rowsToRemove = [];

        $('#pricing-import-table tbody tr').each(function () {
            const checkbox = $(this).find('.row-checkbox');
            if (checkbox.is(':checked')) {
                bypassedData.push({
                    sap_num: $(this).find('input[name*="sap_num"]').val(),
                    z1_price: $(this).find('input[name*="z1_price"]').val(),
                    z2_price: $(this).find('input[name*="z2_price"]').val(),
                    z3_price: $(this).find('input[name*="z3_price"]').val(),
                    z4_price: $(this).find('input[name*="z4_price"]').val(),
                    z5_price: $(this).find('input[name*="z5_price"]').val(),
                });
                rowsToRemove.push($(this));
            }
        });

        if (bypassedData.length === 0) return;

        axios.post('/api/abc_item_pricing/import_pricing', { data: bypassedData }).then(response => {
            rowsToRemove.forEach(row => {
                row.remove();
            });

            // Check if there are no more rows in the table
            if ($('#pricing-import-table tbody tr').length === 0) {
                $('#check-all').prop('checked', false);
                $('#pricing-import-table tbody').html(`
                    <tr>
                        <td colspan="7" class="text-center">No items to price</td>
                    </tr>
                `);

                $('#submit-errors').hide();
                $('#bypass-errors').hide();
            }

        }).catch(error => {
            console.error('Error bypassing pricing:', error);
        });
    },


    /**
     * If the SAP # is defined, has a value, but is not 8 digits long, return false
     */
    validateSAP: function (sap_num) {
        if (sap_num.toString().length !== 8) {
            return false;
        }

        return true;
    },

    tableDrawCallback: function(table){
        // redraw the table with the custom filters applied from the browsers local storage.
        if ($("#pricing_search_terms").html() == ''){
            if (!($.isEmptyObject(abcsetup.abc_item_pricing.manage.imported_sap_nums))) {
                abcsetup.blockUI(true);
                localStorage.setItem('search_sap_list_object', JSON.stringify(abcsetup.abc_item_pricing.manage.imported_sap_nums, {}, 4));
            } else if (!($.isEmptyObject(abcsetup.abc_item_pricing.manage.saved_imported_sap_nums))) {
                abcsetup.blockUI(true);
                abcsetup.abc_item_pricing.manage.imported_sap_nums = abcsetup.abc_item_pricing.manage.saved_imported_sap_nums;
            }
        }
    },
    check_stored_data: function () {
        if (localStorage.getItem("import_pricing_object") !== null) {
            abcsetup.abc_item_pricing.manage.saved_imported_zone_pricing = JSON.parse(localStorage.getItem("import_pricing_object"));
        }
        if (localStorage.getItem("search_sap_list_object") !== null) {
            abcsetup.abc_item_pricing.manage.saved_imported_sap_nums = JSON.parse(localStorage.getItem("search_sap_list_object"));
        }
    },
    check_imported_pricing: function (num) {
        if (abcsetup.abc_item_pricing.manage.imported_zone_pricing !== undefined) {
            if (abcsetup.abc_item_pricing.manage.imported_zone_pricing[num]) {
                var obj = abcsetup.abc_item_pricing.manage.imported_zone_pricing[num];
                var old_z1_price = $("#zone1_retail_price").val();
                var old_z2_price = $("#zone2_retail_price").val();
                var old_z3_price = $("#zone3_retail_price").val();
                var old_z4_price = $("#zone4_retail_price").val();
                var old_z5_price = $("#zone5_retail_price").val();
                $("#zone1_retail_price").val(obj['z1_price']).addClass("border border-success").attr("title", 'Original Zone Price: ' + old_z1_price);
                $("#zone2_retail_price").val(obj['z2_price']).addClass("border border-success").attr("title", 'Original Zone Price: ' + old_z2_price);
                $("#zone3_retail_price").val(obj['z3_price']).addClass("border border-success").attr("title", 'Original Zone Price: ' + old_z3_price);
                $("#zone4_retail_price").val(obj['z4_price']).addClass("border border-success").attr("title", 'Original Zone Price: ' + old_z4_price);
                $("#zone5_retail_price").val(obj['z5_price']).addClass("border border-success").attr("title", 'Original Zone Price: ' + old_z5_price);
            };
        }
    },
    _init_copy: function () {
        if (localStorage.getItem("zone1_price") !== null) {
            var paste_tooltip = "Paste Pricing : <br>" +
                "Zone 1 : $" + localStorage.getItem("zone1_price") + "<br>" +
                "Zone 2 : $" + localStorage.getItem("zone2_price") + "<br>" +
                "Zone 3 : $" + localStorage.getItem("zone3_price") + "<br>" +
                "Zone 4 : $" + localStorage.getItem("zone4_price") + "<br>" +
                "Zone 5 : $" + localStorage.getItem("zone5_price");
            $("a[value='paste_pricing']").show().attr("title", '').attr('data-original-title', paste_tooltip);
            $("a[value='clear_clipboard']").show();
        }
    },
    _init: function () {
        // Called when inititializing from page other than abc_item_pricing/manage
        // Also called to init the edit pricing modal dialog
        abcsetup.abc_item_pricing.manage.remaining_limit = $("#limit_counter").html();
        abcsetup.abc_item_pricing.manage.override = false;
        abcsetup.abc_item_pricing.manage._init_copy();
        $(document).on("click", "a[value='copy_pricing']", function () {

            var num = $("#pricing_modal_id").val();

            // Save the data to the browser's local Storage
            localStorage.setItem('zone1_price', $("input[name='z1_price[" + num + "]']").val() * 1.0);
            localStorage.setItem('zone2_price', $("input[name='z2_price[" + num + "]']").val() * 1.0);
            localStorage.setItem('zone3_price', $("input[name='z3_price[" + num + "]']").val() * 1.0);
            localStorage.setItem('zone4_price', $("input[name='z4_price[" + num + "]']").val() * 1.0);
            localStorage.setItem('zone5_price', $("input[name='z5_price[" + num + "]']").val() * 1.0);

            // Prepare the tooltip for the paste button
            var paste_tooltip = "Paste Pricing : <br>" +
                "Zone 1 : $" + localStorage.getItem("zone1_price") + "<br>" +
                "Zone 2 : $" + localStorage.getItem("zone2_price") + "<br>" +
                "Zone 3 : $" + localStorage.getItem("zone3_price") + "<br>" +
                "Zone 4 : $" + localStorage.getItem("zone4_price") + "<br>" +
                "Zone 5 : $" + localStorage.getItem("zone5_price");

            // Display the paste and clear buttons
            $("a[value='paste_pricing']").show().attr("title", '').attr('data-original-title', paste_tooltip);
            $("a[value='clear_clipboard']").show();
        });
        $(document).on("click", "a[value='paste_pricing']", function () {

            var num = $("#pricing_modal_id").val();

            // Populate the fields with the corresponding 'buffer' values
            $("input[name='z1_price[" + num + "]']").val(localStorage.getItem('zone1_price'));
            $("input[name='z2_price[" + num + "]']").val(localStorage.getItem('zone2_price'));
            $("input[name='z3_price[" + num + "]']").val(localStorage.getItem('zone3_price'));
            $("input[name='z4_price[" + num + "]']").val(localStorage.getItem('zone4_price'));
            $("input[name='z5_price[" + num + "]']").val(localStorage.getItem('zone5_price'));

            // Calculate the new margins
            abcsetup.abc_item_pricing.manage.calc_margins();

            // Trigger the changes on the input fields to test the values and display the margins
            $("input[name='z1_price[" + num + "]']").trigger('change', { revalidate: true });
            // test_all_zone_prices();
        });
        $(document).on("click", "a[value='clear_clipboard']", function () {
            $("a[value='paste_pricing']").hide();
            $("a[value='clear_clipboard']").hide();
            localStorage.removeItem('zone1_price');
            localStorage.removeItem('zone2_price');
            localStorage.removeItem('zone3_price');
            localStorage.removeItem('zone4_price');
            localStorage.removeItem('zone5_price');
        });
        $(document).on("click", "a[value='copy_row_pricing']", function () {
            localStorage.setItem('zone1_price', $(this).data("z1_price") * 1.0);
            localStorage.setItem('zone2_price', $(this).data("z2_price") * 1.0);
            localStorage.setItem('zone3_price', $(this).data("z3_price") * 1.0);
            localStorage.setItem('zone4_price', $(this).data("z4_price") * 1.0);
            localStorage.setItem('zone5_price', $(this).data("z5_price") * 1.0);

            // Prepare the tooltip for the paste button
            var paste_tooltip = "Paste Pricing : <br>" +
                "Zone 1 : $" + localStorage.getItem("zone1_price") + "<br>" +
                "Zone 2 : $" + localStorage.getItem("zone2_price") + "<br>" +
                "Zone 3 : $" + localStorage.getItem("zone3_price") + "<br>" +
                "Zone 4 : $" + localStorage.getItem("zone4_price") + "<br>" +
                "Zone 5 : $" + localStorage.getItem("zone5_price");

            // Display the paste and clear buttons
            $("a[value='paste_pricing']").show().attr("title", '').attr('data-original-title', paste_tooltip);
            $("a[value='clear_clipboard']").show();
        });
        $(document).on("click", "a[value='copy_suggested']", function () {
            var z1_suggested = $('#z1_suggested').data('value');
            var z2_suggested = $('#z2_suggested').data('value');
            var z3_suggested = $('#z3_suggested').data('value');
            var z4_suggested = $('#z4_suggested').data('value');
            var z5_suggested = $('#z5_suggested').data('value');

            $('#zone1_retail_price').val(z1_suggested).trigger('change');
            $('#zone2_retail_price').val(z2_suggested).trigger('change');
            $('#zone3_retail_price').val(z3_suggested).trigger('change');
            $('#zone4_retail_price').val(z4_suggested).trigger('change');
            $('#zone5_retail_price').val(z5_suggested).trigger('change');
        });

        $(document).on("click", "a[value='copy_replacement']", function () {
            var z1_replacement = $('#z1_replacement').data('value');
            var z2_replacement = $('#z2_replacement').data('value');
            var z3_replacement = $('#z3_replacement').data('value');
            var z4_replacement = $('#z4_replacement').data('value');
            var z5_replacement = $('#z5_replacement').data('value');

            $('#zone1_retail_price').val(z1_replacement).trigger('change');
            $('#zone2_retail_price').val(z2_replacement).trigger('change');
            $('#zone3_retail_price').val(z3_replacement).trigger('change');
            $('#zone4_retail_price').val(z4_replacement).trigger('change');
            $('#zone5_retail_price').val(z5_replacement).trigger('change');
        });

        $("button[value='clear_import_data']").click(function (form) {
            // clear the imported data from the local storage
            localStorage.removeItem('import_pricing_object');
            localStorage.removeItem('search_sap_list_object');
            return true;
        });
        // $("a[value='button_supplier_lookup']").click(function() {
        $(document).off('click', "a[value='button_supplier_lookup']");
        $(document).on('click', "a[value='button_supplier_lookup']", function () {
            var tr = $(this).closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var vendor_id = $(this).data('vendor_id');
            var category_id = $(this).data('category');

            if ($("div[id='supplier_lookup']").css("display") == "none") {
                $("div[id='supplier_lookup']").html("");
                // $(this).addClass('loadinginfo');
                $(this).css("cursor", "progress");
                axios.post('/api/abc_item_pricing/similar_supplier_products', { vendor_id: vendor_id, category: category_id }).then(response => {
                    $(this).css("cursor", "pointer");
                    $("div[id='supplier_lookup']").html(response.data);
                    $("div[id='supplier_lookup']").toggle('medium');
                    $('#similar_supplier_pricing_table').DataTable({
                        order: [[1, 'desc']],
                    });
                });
            } else {
                $("div[id='supplier_lookup']").toggle('medium');
                $("div[id='supplier_lookup']").html("");
            }
            return false;
        });

        // $("a[value='button_supplier_wac_lookup']").click(function() {
        $(document).off('click', "a[value='button_supplier_wac_lookup']");
        $(document).on('click', "a[value='button_supplier_wac_lookup']", function () {
            var tr = $(this).closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var vendor_id = $(this).data('vendor_id');
            var wac = tr.data("wac");
            var variance = "0.2";

            if ($("div[id='supplier_wac_products']").css("display") == "none") {
                $("div[id='supplier_wac_products']").html("");
                $(this).addClass('loadinginfo');
                $(this).css("cursor", "progress");
                axios.post('/api/abc_item_pricing/similar_supplier_wac_products', { vendor_id: vendor_id, wac: wac, variance: variance }).then(response => {
                    $(this).css("cursor", "pointer");
                    $("div[id='supplier_wac_products']").html(response.data);
                    $("div[id='supplier_wac_products']").toggle('medium');
                    $('#similar_supplier_pricing_table_wac').DataTable({
                        order: [[1, 'desc']],
                    });
                });
            } else {
                $("div[id='supplier_wac_products']").toggle('medium');
                $("div[id='supplier_wac_products']").html("");
            }
            return false;
        });

        // $("a[value='button_flc_lookup']").click(function() {
        $(document).off('click', "a[value='button_flc_lookup']");
        $(document).on('click', "a[value='button_flc_lookup']", function () {
            var tr = $(this).closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var fineline_code = $(this).data('fineline_code');
            var segment_name = $(this).data('segment_name');
            if ($("div[id='flc_lookup']").css("display") == "none") {
                $("div[id='flc_lookup']").html("");
                // $(this).addClass('loadinginfo');
                $(this).css("cursor", "progress");
                axios.post('/api/abc_item_pricing/similar_flc_products', { fineline: fineline_code }).then(response => {
                    $(this).css("cursor", "pointer");
                    $("div[id='flc_lookup']").html(response.data);
                    $("div[id='flc_lookup']").toggle('medium');
                    $('#similar_flc_pricing_table').DataTable({
                        order: [[2, 'desc']],
                    });

                });
            } else {
                $("div[id='flc_lookup']").toggle('medium');
                $("div[id='flc_lookup']").html("");
            }
            return false;
        });

        $(document).off('click', "#branded_pricing_items tbody tr");
        $(document).on('click', '#branded_pricing_items tbody tr', function (event) {
            $("#branded_pricing_items tbody tr").removeClass('row_selected');
            $(this).addClass('row_selected');
        });
        $(document).off('click', "#similar_supplier_pricing_table tbody tr");
        $(document).on('click', '#similar_supplier_pricing_table tbody tr', function (event) {
            $("#similar_supplier_pricing_table tbody tr").removeClass('row_selected');
            $(this).addClass('row_selected');
        });
        $(document).off('click', "#similar_flc_pricing_table tbody tr");
        $(document).on('click', '#similar_flc_pricing_table tbody tr', function (event) {
            $("#similar_flc_pricing_table tbody tr").removeClass('row_selected');
            $(this).addClass('row_selected');
        });

        // $("button.override_pricing").click(function() {
        $(document).off('click', "button.override_pricing");
        $(document).on('click', "button.override_pricing", function () {
            // override will only ever be available if the item already has pricing information added
            // alert("Please provide the name of the user authorizing this price increase!");

            var num = $("#pricing_modal_id").val();
            var tr = $(this).closest(".pricing_update_form.row");

            abcsetup.abc_item_pricing.manage.override = num;
            var html =
                '<div class="form-group required row">' +
                '<label for="abc_approver_name" class="col-3 col-form-label">Approver Name</label>' +
                '<div class="col-4 col-md-3">' +
                '<div class="input-group">' +
                '<input id="abc_approver_name" name="abc_approver_name[' + num + ']" type="text" class="form-control" required title="Enter the name of the user who is approving this price increase">' +
                '</div>' +
                '</div>' +
                '<div class="col-5">' +
                '<span name="instructions"><i>Please provide the name of the user authorizing this price increase.</i></span>' +
                '</div>' +
                '</div>';
            $("#form_" + num).append(html);
            $("#override").attr('hidden', true);

            $("button[name='update_pricing']").removeClass();
            $("button[name='update_pricing']").addClass('btn btn-primary update_pricing');
            var map_price = tr.data("map_price");
            var wac_price = tr.data("wac");
            var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());

            abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);
        });

        // $("button.update_pricing").click(function() {
        $(document).off('click', "button.update_pricing");
        $(document).on('click', "button.update_pricing", function () {
            $('.modal-feedback').html("");
            if (abcsetup.abc_item_pricing.manage.remaining_limit <= 0) {
                alert('Pricing Limit reached!', 'Warning');
                return false;
            }
            if ($(this).data('blocked')) {
                console.log('blocked button clicked');
                if (confirm("Are you sure you want to change this item's pricing info. These changes will not be part of the next group of master pricing files. They will only be part of the pricing files that follow after the Promotion end date or the month after the consecutive price change.")) {
                    console.log('Confirmed');
                    // Update the pricing in the 'holding' table
                    $(this).addClass('loadinginfo');
                    $(this).html('<span><i class="fas fa-spinner fa-spin"></i>Updating...</span>');
                    var tr = $(this).closest(".pricing_update_form.row");
                    var num = $("#pricing_modal_id").val();
                    var num_type = $("#pricing_modal_id_type").val();
                    console.log("num: " + num);
                    var update_pricing = {};
                    update_pricing[num] = {};
                    tr.find("input").each(function () {
                        if ($(this).prop("readonly")) {
                            return;
                        }
                        var name = $(this).prop("name").replace(/(.*)\[\d*\]/, "$1");
                        update_pricing[num][name] = $(this).val().trim();
                    });
                    update_pricing[num]['type'] = num_type;
                    axios.post('/api/abc_item_pricing/update', { blocked: true, update_pricing: update_pricing }).then(response => {
                        $(this).css("cursor", "pointer");
                        if (response.data.error) {
                            $("button.update_pricing").html("Update");
                            $('.modal-feedback').html('<div class="alert alert-danger">' + response.data.error + '</div>');
                        } else {
                            console.log("abc_item_pricing/update: result" + JSON.stringify(response.data, {}, 4));
                            $("button.update_pricing").removeClass('btn-danger').removeClass('btn-primary').addClass('btn-success').html("Update");
                            $('.modal-feedback').html('<div class="alert alert-success">Pricing Update Scheduled</div>');
                            axios.post('/api/abc_item_pricing/remaining_pricing_limit').then(response => {
                                console.log('remaining_pricing_limit', response.data);
                                if (response.data) {
                                    remaining_limit = response.data.result;
                                    $("#limit_counter").html(remaining_limit);
                                } else {
                                    $("#limit_counter").html("Limit ERROR");
                                }
                            });
                        }
                    });

                } else {
                    console.log('Cancelled');
                    // Do nothing
                }
                return false;
            }
            $(this).removeClass();
            $(this).addClass('btn btn-primary update_pricing');
            $(this).html('<span><i class="fas fa-spinner fa-spin"></i>Updating...</span>');
            var tr = $(this).closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            var num = $("#pricing_modal_id").val();
            var num_type = $("#pricing_modal_id_type").val();

            console.log("num: " + num);
            console.log("num_type: " + num_type);

            var update_pricing = {};
            update_pricing[num] = {};
            var abc_approver_name = null;
            if (abcsetup.abc_item_pricing.manage.override == num) {
                var abc_approver_name = $("input[name='abc_approver_name[" + num + "]']").val().trim();
            }
            if (abcsetup.abc_item_pricing.manage.override == num) {
                if (abc_approver_name == '') {
                    $(this).removeClass();
                    $(this).addClass('btn btn-primary update_pricing').html("Update");
                    alert("Please provide the name of the user authorizing this price increase!");
                    return false;
                }
            }
            tr.find("input").each(function () {
                if ($(this).prop("readonly")) {
                    return;
                }
                var name = $(this).prop("name").replace(/(.*)\[\d*\]/, "$1");
                if (name) {
                    update_pricing[num][name] = $(this).val().trim();
                }
            });
            update_pricing[num]['type'] = num_type;
            console.log("update_pricing:" + JSON.stringify(update_pricing, {}, 4));

            axios.post('/api/abc_item_pricing/update', { update_pricing: update_pricing }).then(response => {
                $(this).css("cursor", "pointer");
                if (response.data.error) {
                    $("button.update_pricing").removeClass('btn-primary').addClass('btn-danger').html("Update");
                    $('.modal-feedback').html('<div class="alert alert-danger">' + response.data.error + '</div>');
                } else {
                    console.log("abc_item_pricing/update: result" + JSON.stringify(response.data, {}, 4));
                    $("button.update_pricing").removeClass('btn-primary').addClass('btn-success').html("Update");
                    $('.modal-feedback').html('<div class="alert alert-success">Pricing Updated</div>');
                    axios.post('/api/abc_item_pricing/remaining_pricing_limit').then(response => {
                        console.log('remaining_pricing_limit', response.data);
                        if (response.data) {
                            remaining_limit = response.data.result;
                            $("#limit_counter").html(remaining_limit);
                        } else {
                            $("#limit_counter").html("Limit ERROR");
                        }
                    });
                }
            });
        });

        $(document).on('change blur', "#zone1_retail_price", function () {
            $("button[name='update_pricing']").removeClass();
            $("button[name='update_pricing']").addClass('btn btn-primary update_pricing');
            var tr = $(this).closest("form").closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var map_price = tr.data("map_price");
            var wac_price = tr.data("wac");
            var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());

            abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

            return false;
        });

        $(document).on('change blur', "#zone2_retail_price", function () {
            $("button[name='update_pricing']").removeClass();
            $("button[name='update_pricing']").addClass('btn btn-primary update_pricing');
            var tr = $(this).closest("form").closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var map_price = tr.data("map_price");
            var wac_price = tr.data("wac");
            var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());

            abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

            return false;
        });

        $(document).on('change blur', "#zone3_retail_price", function () {
            $("button[name='update_pricing']").removeClass();
            $("button[name='update_pricing']").addClass('btn btn-primary update_pricing');
            var tr = $(this).closest("form").closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var map_price = tr.data("map_price");
            var wac_price = tr.data("wac");
            var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());

            abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

            return false;
        });

        $(document).on('change blur', "#zone4_retail_price", function () {
            $("button[name='update_pricing']").removeClass();
            $("button[name='update_pricing']").addClass('btn btn-primary update_pricing');
            var tr = $(this).closest("form").closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var map_price = tr.data("map_price");
            var wac_price = tr.data("wac");
            var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());

            abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

            return false;
        });

        $(document).on('change blur', "#zone5_retail_price", function () {
            $("button[name='update_pricing']").removeClass();
            $("button[name='update_pricing']").addClass('btn btn-primary update_pricing');
            var tr = $(this).closest("form").closest(".pricing_update_form.row");
            var num = tr.data("sap_num");
            if (num === undefined) {
                num = tr.data("entity_id");
            }
            var map_price = tr.data("map_price");
            var wac_price = tr.data("wac");
            var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());

            abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

            return false;
        });
    },
    calc_margins: function () {
        // num could be the sap_num if abc_item_pricing view is used
        // OR entity_id if the new_items_pricing view is used
        var num = $("#pricing_modal_id").val();
        var tr = $(".pricing_update_form.row." + num);
        var map_price = tr.data("map_price");
        var wac_price = tr.data("wac");
        var zone1_price_input = $("input[name='z1_price[" + num + "]']");
        var zone2_price_input = $("input[name='z2_price[" + num + "]']");
        var zone3_price_input = $("input[name='z3_price[" + num + "]']");
        var zone4_price_input = $("input[name='z4_price[" + num + "]']");
        var zone5_price_input = $("input[name='z5_price[" + num + "]']");

        var zone1_price = zone1_price_input.val() * 1.0;
        var zone2_price = zone2_price_input.val() * 1.0;
        var zone3_price = zone3_price_input.val() * 1.0;
        var zone4_price = zone4_price_input.val() * 1.0;
        var zone5_price = zone5_price_input.val() * 1.0;

        // '(aip.z1_price*1000-(a.wac/COALESCE(a.retail_pack_qty,a.retail_sticker_qty))*1000)/aip.z1_price z1_margin,'.
        // '((aip.z1_price)/(a.wac/COALESCE(a.retail_pack_qty,a.retail_sticker_qty))-1)*100000 z1_multiplier,'.
        var margin1 = (zone1_price - wac_price) / zone1_price * 100;
        var margin2 = (zone2_price - wac_price) / zone2_price * 100;
        var margin3 = (zone3_price - wac_price) / zone3_price * 100;
        var margin4 = (zone4_price - wac_price) / zone4_price * 100;
        var margin5 = (zone5_price - wac_price) / zone5_price * 100;

        var multiplier1 = (zone1_price / wac_price) - 1;
        var multiplier2 = (zone2_price / wac_price) - 1;
        var multiplier3 = (zone3_price / wac_price) - 1;
        var multiplier4 = (zone4_price / wac_price) - 1;
        var multiplier5 = (zone5_price / wac_price) - 1;

        $("span[name='margin1']").html("Margin: " + margin1.toFixed(2) + "%&nbsp;");
        $("span[name='margin2']").html("Margin: " + margin2.toFixed(2) + "%&nbsp;");
        $("span[name='margin3']").html("Margin: " + margin3.toFixed(2) + "%&nbsp;");
        $("span[name='margin4']").html("Margin: " + margin4.toFixed(2) + "%&nbsp;");
        $("span[name='margin5']").html("Margin: " + margin5.toFixed(2) + "%&nbsp;");

        $("span[name='multiplier1']").html("Multiplier: " + multiplier1.toFixed(5));
        $("span[name='multiplier2']").html("Multiplier: " + multiplier2.toFixed(5));
        $("span[name='multiplier3']").html("Multiplier: " + multiplier3.toFixed(5));
        $("span[name='multiplier4']").html("Multiplier: " + multiplier4.toFixed(5));
        $("span[name='multiplier5']").html("Multiplier: " + multiplier5.toFixed(5));

    },

    test_all_zone_prices: function (num, map_price, wac_price, pricing_data) {
        //-Calculate and display margins
        //-if map is populated: WARN if Zone 1 is lower than MAP
        //-NO zone below WAC
        //-WARN if Zone 1 is less than 26%
        //-NOT ALLOWED : Zone 2 < Zone 1 , Zone 3 < Zone 2 , Zone 4 < Zone 3 , Zone 4 < Zone 5

        //OTHER:
        //-		All retail prices must end in a 9
        //*NUL	Changes are only made when the change is $0.10 or greater
        //-		Any price that ends in .09 should be rounded up to .19
        //-EXC_1 No price can increase more than $1.00 from its current price
        //EXC_1  :Allow override of price increase with approver name
        //*PRE	An item can NOT change retail price two months in a row.

        let zone_prices = [], zone_price_inputs = [], zone_org_prices = [];
        let penny_profits = [], margins = [], multipliers = [];
        let nbeZ = [], z = [], z_dollar = [];
        let nbePennyProfits = [];
        let retail_wac = pricing_data.wac / pricing_data.retail_pack_qty;

        for (let i = 1; i <= 5; i++) {
            zone_price_inputs[i] = $("input[name='z" + i + "_price[" + num + "]']");
            zone_prices[i] = zone_price_inputs[i].val() * 1.0;
            zone_org_prices[i] = zone_price_inputs[i].data('original_price');
            penny_profits[i] = zone_prices[i] - retail_wac;
            margins[i] = (zone_prices[i] - wac_price) / zone_prices[i] * 100;
            multipliers[i] = (zone_prices[i] / wac_price) - 1;
            nbeZ[i] = $('#nbe-item-z' + i + '-price').data('value');
            nbePennyProfits[i] = $('#nbe-item-penny-profit' + i).data('value');
            z[i] = false;
            z_dollar[i] = false;
        }

        let allValid = true;

        let updateUI = function (index) {
            if (zone_prices[index] != '') {
                $("#penny_profit" + index).html("Penny Profit: $" + penny_profits[index].toFixed(2)).addClass('pr-2 pl-2');
                if (penny_profits[index] < nbePennyProfits[index]) {
                    $("#nbe-item-penny-profit" + index).addClass('alert alert-danger danger');
                    $("#nbe-item-penny-profit" + index).attr('title', 'NBE Penny Profit is greater than GNP Penny Profit').html("NBE Penny Profit is greater than GNP Penny Profit");
                } else {
                    $("#nbe-item-penny-profit" + index).removeClass('alert alert-danger danger');
                    $("#nbe-item-penny-profit" + index).attr('title', '').html("");
                }

                let gnp_savings = ((nbeZ[index] - zone_prices[index]) / nbeZ[index]) * 100;
                $("#gnp_savings" + index).html("GNP Savings: " + (gnp_savings.toFixed(1)) + "%");
                if (gnp_savings < 25.00) {
                    $("#gnp_savings" + index).addClass('alert alert-danger danger').attr('title', 'Please adjust pricing so that GNP Savings is at least 25%');
                } else {
                    $("#gnp_savings" + index).removeClass('alert alert-danger danger');
                }

                if (zone_org_prices[index] != "" && zone_prices[index] > (zone_org_prices[index] + 1) && (abcsetup.abc_item_pricing.manage.override != num)) {
                    z_dollar[index] = true;
                    allValid = false;
                    $("span[name='margin" + index + "']").html("Prices are not allowed to be increased by more than a dollar!").addClass('alert alert-danger');
                    $("span[name='multiplier" + index + "']").html("");
                    $('#override').attr('hidden', false);
                } else if (zone_prices[index] < wac_price) {
                    allValid = false;
                    $("span[name='margin" + index + "']").html("No Zone Price is allowed to be below the WAC!").addClass('alert alert-danger');
                    $("span[name='multiplier" + index + "']").html("");
                    $('#override').attr('hidden', false);
                } else if ((zone_prices[index] % 0.1).toFixed(2) != 0.09) {
                    allValid = false;
                    $("span[name='margin" + index + "']").html("All prices should end with 9!").addClass('alert alert-danger');
                    $("span[name='multiplier" + index + "']").html("");
                } else if ((zone_prices[index] % 1).toFixed(2) == 0.09) {
                    allValid = false;
                    $("span[name='margin" + index + "']").html("Any price that ends in .09 should be rounded up to .19!").addClass('alert alert-danger');
                    $("span[name='multiplier" + index + "']").html("");
                } else if (index > 1 && zone_prices[index] < zone_prices[index - 1]) {
                    allValid = false;
                    $("span[name='margin" + index + "']").html("Zone " + index + " price must be greater than or equal to Zone " + (index - 1) + "!").addClass('alert alert-danger');
                    $("span[name='multiplier" + index + "']").html("");
                } else {
                    $("span[name='margin" + index + "']").html("Margin: " + margins[index].toFixed(2) + "%&nbsp").removeClass('alert alert-danger');
                    $("span[name='multiplier" + index + "']").html("Multiplier: " + multipliers[index].toFixed(5));
                    if (zone_prices[index] < map_price) {
                        $("span[name='margin" + index + "']").addClass('alert alert-warning').attr('title', 'Zone ' + index + ' pricing is less than MAP');
                    } else if (margins[index] < 26) {
                        $("span[name='margin" + index + "']").addClass('alert alert-warning').attr('title', 'Zone ' + index + ' margin is less than 26%');
                    } else {
                        $("span[name='margin" + index + "']").removeClass('alert alert-warning').attr('title', '');
                    }
                    z[index] = true;
                }
            } else {
                z[index] = false;
                z_dollar[index] = false;
                allValid = false;
                $("span[name='margin" + index + "']").html("Field cannot be left blank!").addClass('alert alert-danger');
                $("span[name='multiplier" + index + "']").html("");
            }
        };

        for (var i = 1; i <= 5; i++) {
            updateUI(i);
        }

        // Enable the update button if all zones are valid
        if (allValid) {
            $("#update").removeAttr('disabled').removeAttr('title').removeClass('disabled');
        } else {
            $("#update").attr('disabled', true).attr('title', 'Please enter valid pricing information.');
        }
    },

    render_search_terms: function(){
        $("#pricing_search_terms").removeClass("alert alert-success search_terms").html("");
        var search_terms = '';
        var label = '';
        var val = '';
        $('#pricing_search').find(':input').each(function(){
            if ($(this).val()){
                val = $(this).val();
                if ($(this).find('option:selected') && $(this).find('option:selected').text()){
                    val = $(this).find('option:selected').map(function () {
                        if ($(this).val().length)
                            return $(this).text();
                    }).get().join(',');
                }
                if (val.length){
                    label = $('label[for="' + $(this).attr('id') + '"]').html();
                    search_terms += "<b>"+label+"</b>: "+val+" ";
                }
            }
        });
        console.log('search_terms:',search_terms);
        if (search_terms){
            search_terms = "Results filtered on : " + search_terms;
            $("#pricing_search_terms").addClass("alert alert-success search_terms").html(search_terms);
        }
    },
};

// function render_comp_shops_data_table(sap_num) {

//    var comp_shops_div = $("#comp_shops");
//    comp_shops_div.addClass('loadinginfo');
//    $.ajax({
//       type: "POST",
//       url: BASE_URL+"/comp_shops/render_table/"+sap_num,
//       cache: false,
//       dataType: 'json',
//    })
//    .done(function(result) {
//       if (result){
//          comp_shops_div.html('').append(result);
//          comp_shops_div.removeClass('loadinginfo');
//       } else {
//          comp_shops_div.removeClass('loadinginfo');
//       }
//    });
// 	return false;
// };

// $(document).on("click", '.sap_search', function(event) {
//    // executed when the user clicks on a SAP #'s in one of the displayed data tables
//    var sap_num_search = $(this).html("");
//    var num = $(this).closest(".row.pricing_update_form").data("sap_num");
//    if (num === undefined){
//       num = $(this).closest(".row.pricing_update_form").data("entity_id");
//    }

//    localStorage.setItem('zone1_price',$("input[name='z1_price["+num+"]']").val()*1.0);
// 	localStorage.setItem('zone2_price',$("input[name='z2_price["+num+"]']").val()*1.0);
// 	localStorage.setItem('zone3_price',$("input[name='z3_price["+num+"]']").val()*1.0);
// 	localStorage.setItem('zone4_price',$("input[name='z4_price["+num+"]']").val()*1.0);
// 	localStorage.setItem('zone5_price',$("input[name='z5_price["+num+"]']").val()*1.0);
//    window.location.href = BASE_URL+"/abc_item/pricing?sap_num="+sap_num_search;
// });